<template>
  <div style="width: 100%; height: 100%">
    <div class="login-module">
      <div class="left-box">
        <img
          class="background-image"
          src="../../../static/images/start_page.png"
          alt
        />
      </div>
      <div class="right-box">
        <div class="login-box">
          <div class="logo">
            <img src="../../../static/images/logo2.png" />
          </div>
          <div class="system_name">蓝茨盆底肌训练仪-后台管理系统</div>
          <span class="greeting">欢迎回来, 请登录！</span>
          <div class="account-module">
            <div class="input_content">
              <input
                placeholder="账号"
                v-model="form.phone"
                class="account-input"
                @keyup.enter="goLogin"
                @blur="checkInput('1')"
              />
              <img
                src="../../../static/images/login_account.png"
                class="input-icon-img"
              />
            </div>
            <div class="password-box input_content">
              <input
                class="password-input"
                type="password"
                placeholder="密码"
                v-model="form.password"
                @keyup.enter="goLogin"
                @blur="checkInput('2')"
              />
              <img
                src="../../../static/images/login_password.png"
                class="input-icon-img"
              />
            </div>
            <div style="width: 100%">
              <div class="error-tips">{{ errorTipsText }}</div>
              <!-- <a class="forget-word" @click="findPassword('updatePassword')">忘记密码</a> -->
            </div>
          </div>
          <button class="login-button" @click="goLogin">登&nbsp;录</button> 
        </div>
        <!-- <div class="foot_content">
          <p>电话：0757-85756161     &nbsp;&nbsp;邮箱：naidean@163.com     地址：广东省佛山市南海区大沥镇盐步联安周边村周日电商园3F</p>
          <p> <a href="http://www.naidean.com" target="_blank">www.naidean.com 佛山市耐得安智能科技有限公司版权所有.</a> &nbsp;&nbsp;&nbsp;&nbsp;备案号：粤ICP19068381号</p>
        </div> -->
      </div>
    </div>
    <!-- 找回密码 -->
    <el-dialog
      title="忘记密码"
      :visible.sync="dialog_find_password"
      width="540px" :close-on-click-modal="false"
    >
      <div class="dialog_context">
        <el-form :model="updateForm" :rules="rules" ref="updatePassword">
          <el-form-item
            label="手机号"
            :label-width="formLabelWidth"
            prop="phone"
          >
            <el-input
              type="number"
              v-model="updateForm.phone"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="验证码"
            :label-width="formLabelWidth"
            prop="code"
          >
            <el-input
              type="number"
              v-model="updateForm.code"
              autocomplete="off"
            >
            <template slot="append">
                 <div style="width:80px;text-align:center;">
                  <el-button v-if="codeTime == 0" :disabled="codeTime > 0" @click="getCode()">
                    <span class="get_code">获取验证码</span>
                  </el-button>
                  <span v-if="codeTime > 0">
                    <!-- {{codeTime == 0?"获取验证码":"重新发送("+codeTime+")"}} -->
                    重新发送({{codeTime}})
                  </span>
                  </div>
               </template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="新密码"
            :label-width="formLabelWidth"
            prop="newPassword"
          >
            <el-input
              type="password"
              v-model="updateForm.newPassword"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="确认密码"
            :label-width="formLabelWidth"
            prop="checkPassword"
          >
            <el-input
              type="password"
              v-model="updateForm.checkPassword"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_find_password = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdatePassowrd('updatePassword')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    // 校验手机号
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      if (!/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error("手机号不正确"));
      }
      callback();
    };

    return {
      // yourPhone: localStorage.getItem("rememberhldaccount"),
      // yourPassword: "",
      errorTips: false,
      errorTipsText: "",
      // 找回密码弹出框
      dialog_find_password: false,
      formLabelWidth: "80px",
      form: {
        phone: null,
        password: null
      },
      updateForm:{
        code: null,
        phone: null,
        newPassword: null,
        checkPassword: null
      },
      // 校验规则
      rules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码在 6 到 20 个之间",
            trigger: "blur",
          },
        ],
        newPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码在 6 到 20 个之间",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "请输入6位验证码", trigger: "blur" },
          { min: 6, max: 6, message: "请输入6位验证码", trigger: "blur" },
        ],
        checkPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "密码在 6 到 20 个之间",
            trigger: "blur",
          },
        ],
      },
      codeTime: 0,
    };
  },
  created() {
    // 查询IP地址和城市名
    
  },
  computed: {},
  methods: {
    // 点击忘记密码,打开弹出框
    findPassword(ref) {
      //this.clearValidate("updatePassword")
      this.updateForm.phone = this.form.phone;
      this.updateForm.newPassword = "";
      this.updateForm.checkPassword = ""
      this.updateForm.code = "";
      
      this.dialog_find_password = true;
      //this.$refs[ref].clearValidate();
      if(typeof(this.$refs[ref].resetFields()) != undefined){
        console.log("处理")
        this.$refs[ref].resetFields();
      }
      
    },
    checkInput(res) {
      this.errorTips = false;
      this.errorTipsText = "";
      if (res == 1) {
        if (!this.form.phone || this.form.phone == "") {
          this.errorTips = true;
          this.errorTipsText = "账号不能为空";
          return false;
        }

        if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
          this.errorTips = true;
          this.errorTipsText = "账号格式错误";
          return false;
        }
      } else if (res == 2) {
        if (!this.form.password || this.form.password == "") {
          this.errorTips = true;
          this.errorTipsText = "密码不能为空";
          return false;
        }

        if (this.form.password.length < 6 || this.form.password.length > 20) {
          this.errorTips = true;
          this.errorTipsText = "密码长度为6到20位";
          return false;
        }
      } else {
        if (
          (!this.form.phone || this.form.phone == "") &&
          (!this.form.password || this.form.password == "")
        ) {
          this.errorTips = true;
          this.errorTipsText = "请输入账号和密码";
          return false;
        }
        if (!this.form.phone || this.form.phone == "") {
          this.errorTips = true;
          this.errorTipsText = "账号不能为空";
          return false;
        }

        if (!this.form.password || this.form.password == "") {
          this.errorTips = true;
          this.errorTipsText = "密码不能为空";
          return false;
        }

        if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
          this.errorTips = true;
          this.errorTipsText = "账号格式错误";
          return false;
        }

        if (this.form.password.length < 6 || this.form.password.length > 20) {
          this.errorTips = true;
          this.errorTipsText = "密码长度为6到20位";
          return false;
        }
      }
      return true;
    },
    getCode(){
    
      let that = this;

       this.$axios
          .post("/web/other/sendSmsCode",{
            phone: this.updateForm.phone
          })
          .then(res => {
            console.log(res.data);
            if (res.data.code == 1000) {
              that.$message.success("验证码发送成功！");
              this.codeTime = 60;
              let intervalCodeTime = setInterval(function(){
                that.codeTime = that.codeTime - 1;
                console.log("倒计时："+that.codeTime)
                if(that.codeTime <= 0){
                  console.log("结束")
                  clearInterval(intervalCodeTime);
                }
              },1000)
            } else if(res.data.code == 2001){
              that.$message.error("登录失效，请重新登录");
              that.$router.push({ path: "/login" });
            } else{
              this.$message.error(res.data.message);
            }
            this.dialogFormVisible = false;
          })
          .catch(err => {
            console.log(err);
          });
    },
    submitUpdatePassowrd(ref) {
      let that = this;
      this.$refs[ref].validate(valid => {
        // 校验结果
        if (!valid) {
          // 校验不通过
          return;
        }

        if(this.updateForm.checkPassword != this.updateForm.newPassword){
          that.$message.error("两次密码不一致！");
          return;
        }

        const url = "/web/login/updatePassword";
        this.$axios
          .post(url, {
            phone: this.updateForm.phone,
            code: this.updateForm.code,
            password: this.updateForm.newPassword
          })
          .then(res => {
            console.log(res.data);
            if (res.data.code == 1000) {
              this.$message({
                message: "密码修改成功",
                type: "success"
              });
              this.dialog_find_password = false;
            } else if(res.data.code == 2001){
              that.$message.error("登录失效，请重新登录");
              that.$router.push({ path: "/login" });
            } else {
              this.$message.error(res.data.message);
            }
            this.dialogFormVisible = false;
          })
          .catch(err => {
            console.log(err);
          });
      })
    },
    // 点击登录
    goLogin() {
      if (!this.checkInput()) {
        return;
      }
      let that = this;
  
      //点击登录按钮
      this.errorTips = false;
      const url = "/api/web/admin/login";
      this.$axios
        .post(url, {
          account: this.form.phone,
          password: this.form.password
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.code == 1000) {
            that.$message({
              message: "登录成功",
              type: "success",
            });
            localStorage.setItem("isLogin",true);
            sessionStorage.setItem("isLogin", true);
            localStorage.setItem( "authorization", res.data.data.token );
            sessionStorage.setItem( "authorization", res.data.data.token );
            that.$axios.defaults.headers.common["Authorization"] = res.data.data.token;
            localStorage.setItem("user",JSON.stringify(res.data.data));
            sessionStorage.setItem("user",JSON.stringify(res.data.data));
            
            setTimeout(() => {
              that.$router.push({ path: "/home" });
            }, 1000);
          } else if (res.data.code == 1002) {
            that.errorTips = true;
            that.errorTipsText = "账号或密码错误,请重新输入";
          } else if (res.data.code == 2002) {
            that.errorTips = true;
            that.errorTipsText = "账号已禁用，请联系系统管理员";
          } else {
            that.$message.error("登录失败");
          }
        })
        .catch((err) => {
          console.log("错误",err);
        });
    },
  },
};
</script>
<style scoped>
@import "../../../static/css/login.css";
</style>
<style>
/** 底部备案信息 */
.foot_content{
  position:absolute;
  bottom: 0px;
  height: 60px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/account/login.vue